import React, { useEffect, useState } from 'react';
import { BsClipboardPlus } from 'react-icons/bs';
import { Tooltip } from 'react-tooltip';
import { _$ } from '../../../../controllers/dom';
import { locales } from '../../../../translations/locales';
import Loading from '../../../Loading';
import Authorizations from './Authorizations';

const ManageRank = (props) => {
    const { theme, locale, ModuleRP, data } = props;

    const [confirmDelete, setConfirmDelete] = useState(false);
    const copyClipboard = () => {
        navigator.clipboard.writeText(data.id)
            .then(() => {
                NotificationManager.success(locales[locale].notifications.copySuccess, '', 3000);
            })
            .catch(() => {
                NotificationManager.error(locales[locale].notifications.copyError, '', 3000);
            });
    };
    const updateRank = () => {
        const authorizations = {
            bip: _$('bip').checked,
            radio: _$('radio').checked,
            planning: _$('planning').checked,
            operations: _$('operations').checked,
            alerts: _$('alerts').checked,
            config: false,
            superAdmin: _$('superAdmin').checked,
            admin: {
                shop: {
                    new: _$('shop-new').checked,
                    manage: _$('shop-manage').checked,
                    delete: _$('shop-delete').checked,
                },
                players: {
                    new: _$('players-new').checked,
                    manage: _$('players-manage').checked,
                    delete: _$('players-delete').checked,
                },
                buildings: {
                    new: _$('buildings-new').checked,
                    manage: _$('buildings-manage').checked,
                    delete: _$('buildings-delete').checked,
                },
                vehicleModels: {
                    new: _$('vehicleModels-new').checked,
                    manage: _$('vehicleModels-manage').checked,
                    delete: _$('vehicleModels-delete').checked,
                },
                functions: {
                    new: _$('functions-new').checked,
                    manage: _$('functions-manage').checked,
                    delete: _$('functions-delete').checked,
                },
                skills: {
                    new: _$('skills-new').checked,
                    manage: _$('skills-manage').checked,
                    delete: _$('skills-delete').checked,
                },
                ranks: {
                    new: _$('ranks-new').checked,
                    manage: _$('ranks-manage').checked,
                    delete: _$('ranks-delete').checked,
                },
                status: {
                    new: _$('status-new').checked,
                    manage: _$('status-manage').checked,
                    delete: _$('status-delete').checked,
                },
                services: {
                    new: _$('services-new').checked,
                    manage: _$('services-manage').checked,
                    delete: _$('services-delete').checked,
                },
                incidents: {
                    new: _$('incidents-new').checked,
                    manage: _$('incidents-manage').checked,
                    delete: _$('incidents-delete').checked,
                },
                geographicSystem: _$('geographicSystem').checked,
            },
        };
        let configAccess = false;
        for (const key in authorizations.admin) {
            if (Object.hasOwnProperty.call(authorizations.admin, key)) {
                const element = authorizations.admin[key];
                for (const value in element) {
                    if (Object.hasOwnProperty.call(element, value)) {
                        if (element[value]) {
                            configAccess = true;
                        }
                    }
                }
            }
        }
        if (configAccess) {
            authorizations.config = true;
        }
        const params = ['id', 'name', 'authorizations'];
        const values = [data.id, _$('rankName').value, authorizations];
        ModuleRP.config.updateRank(params, values);
    };

    useEffect(() => {
        // new render when data changes
    }, [data]);

    return (
        data.type === 'rank' ?
            <div className={`container p-0 bg-${theme === 'DARK' ? 'dark text-light' : 'light text-dark'}`}>
                <div className="card container p-0 gameInformations mt-5">
                    <h5 className="card-header bg-primary">{locales[locale].config.managePlayer}</h5>
                    <div className={`card-body bg-${theme === 'DARK' ? 'dark' : 'light'}`}>
                        <form onSubmit={(event) => {
                            event.preventDefault();
                            updateRank();
                        }}>
                            <div className='form-group'>
                                <label htmlFor='rankName'>
                                    {locales[locale].config.rankName}
                                    <span className='text-info m-1'>{locales[locale].config.required}</span>
                                </label>
                                <input
                                    type='text'
                                    id='rankName'
                                    className='form-control w-100'
                                    placeholder={locales[locale].config.rankName}
                                    defaultValue={data.name}
                                />
                            </div>
                        </form>
                        <div className="card-text text-secondary">
                            <span className={`text-${theme === 'DARK' ? 'light' : 'dark'}`}>
                                {data.id}
                            </span>
                            <span
                                className={`text-${theme === 'DARK' ? 'light' : 'dark'} m-1 cursor-pointer`}
                                data-tip data-tooltip-id='copy'
                                onClick={copyClipboard}
                            >
                                <BsClipboardPlus />
                                <Tooltip id='copy' place='top' effect='solid' className='text-center'>
                                    {locales[locale].config.copyClipboard}
                                </Tooltip>
                            </span>
                        </div>
                        <form>
                            <div className='form-group'>
                                <label htmlFor='rankName'>
                                    {locales[locale].config.authorizations}
                                </label>
                                <Authorizations theme={theme} locale={locale} data={data} />
                            </div>
                        </form>
                        <button
                            type='button' id='btn-confirm-update-rank' className="btn btn-primary float-right" onClick={updateRank}>
                            {locales[locale].config.update}
                        </button>
                    </div>
                </div>
                <div className="card container p-0 gameInformations mt-5 mb-2">
                    <div className={`card-body bg-${theme === 'DARK' ? 'dark' : 'light'}`}>
                        <div className="row">
                            <div className="col-sm-8"></div>
                            <div className='col h-25 btn btn-danger' onClick={() => setConfirmDelete(true)}>
                                {locales[locale].config.deleteRank}
                            </div>
                        </div>
                        <div className={confirmDelete ? '' : 'hide'} id="deleteRank">
                            <hr className={`m-1 bg-secondary`} />
                            <div>
                                {locales[locale].config.deleteConfirmRank}
                            </div>
                            <div className="text-center">
                                <button className='btn btn-sm btn-secondary w-25 m-3' onClick={() => setConfirmDelete(false)}>
                                    {locales[locale].no}
                                </button>
                                <button
                                    className='btn btn-sm btn-danger w-25 m-3'
                                    id='btn-delete-rank'
                                    onClick={() => {
                                        ModuleRP.config.deleteRank(data.id);
                                    }}
                                >
                                    {locales[locale].yes}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div> :
            <Loading theme={theme} />
    );
};

export default ManageRank;
